import type { ReactElement } from 'react';

import './loading.css';

/**
 * "Hleð", inside a turning ring, centred on both axes.
 *
 * One component rather than the paragraph each surface used to write for
 * itself: a route being lazily fetched, a catalog request and an exercise item
 * are the same event to the person waiting, and they were previously three
 * different-looking screens.
 *
 * The ring is decorative -- `role="status"` on the wrapper plus the visible
 * word is the whole accessible message, and a screen reader that also announced
 * the spinner would say "Hleð" twice.
 */
export function Loading({
  /**
   * `page` centres against the viewport, for a route that has drawn nothing
   * yet. `inline` centres inside the block it replaces, for a page whose header
   * and tabs are already on screen -- centring *that* against the viewport
   * would slide the ring up underneath them.
   */
  variant = 'page',
  /** Overrides the visible word; the ring is unchanged. */
  label = 'Hleð',
}: {
  variant?: 'page' | 'inline';
  label?: string;
} = {}): ReactElement {
  return (
    <div className={`loading loading--${variant}`} role="status" aria-live="polite">
      <span className="loading__ring" aria-hidden />
      <span className="loading__text">{label}</span>
    </div>
  );
}
